import {Grid, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Check, Clear, Email, Phone} from "@mui/icons-material";
import React, {useEffect} from "react";
import {isDate} from "../../Utils/dateUtils";
import moment from "moment";
import Swal from "sweetalert2";
import {actions as opportunityActions, selectors as opportunitySelectors} from '../../../Ducks/opportunity';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {VerifiedEmailIcon} from "../Overview/VerifiedEmailIcon";

function PersonJobOverview(props) {
    const {
        job,
        companies,
        editJobEmail,
        setEditJobEmail,
        updatePrimaryJobEmail,
        person,
        updatePrimaryJobEmailError
    } = props;
    const [email, setEmail] = React.useState(job?.job_email);
    const getCompanyName = (companyId) => {
        const company = Object.values(companies)?.find((item) => item.company_id === companyId);
        return company ? company.company_name : "";
    };
    const getYears = (date, end_date) => {
        let d = new Date(date);
        let start = d.getFullYear();

        if (!isDate(date)) {
            return "";
        }

        if (end_date === null) {
            let c = new Date();
            let current = c.getFullYear();
            return Math.ceil(parseInt(current) - parseInt(start));
        } else {
            let e = new Date(end_date);
            let end = e.getFullYear();
            return Math.ceil(parseInt(end) - parseInt(start));
        }
    };

    useEffect(() => {
        if (job) {
            setEmail(job?.job_email);
        }
    }, [job]);

    useEffect(() => {
        if (updatePrimaryJobEmailError?.message && job) {
            setEmail(job?.job_email);
        }
    }, [updatePrimaryJobEmailError]);


    const handleUpdatePrimaryJobEmailCheck = () => {
        if (email && job.job_email !== email) {
            let contactData = {
                jobID: job.job_id,
                personId: person.person_id,
                obj: {job_email: email},
            }

            Swal.fire({
                title: 'Are you sure?',
                text: `By confirming, ${person.person_firstname} ${person.person_lastname} 
                    will receive the invitation for all upcoming events at the ${email}.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel'
            })
                .then(result => {
                    if (result.isConfirmed) {
                        updatePrimaryJobEmail(contactData)
                    } else {
                        setEmail(job?.job_email);
                    }
                });
        }

        setEditJobEmail(false);
    }

    return (
        <Grid container spacing={2} sx={{
            padding: "10px 0",
            borderTop: "1px solid #c2c2c2",
            marginTop: 0
        }}>
            <Grid item xs={4} sx={{paddingTop: "0 !important"}}>
                <Typography style={{fontSize: "13px"}} gutterBottom variant='h6'
                            component='div'>
                    {job?.division && getCompanyName(job?.division.company_id)}
                </Typography>

                <Typography
                    style={{flexGrow: "1", fontSize: "11px"}}
                    gutterBottom
                    variant='span'
                    component='span'
                >
                    {
                        isDate(job?.job_start) && <>
                            {moment(job?.job_start).format("DD/MM/YYYY")} - {" "}
                            {
                                job?.job_stop === null ?
                                    <>
                                        Present - {getYears(job?.job_start, null)} years
                                    </> :
                                    <>
                                        {moment(job?.job_stop).format("DD/MM/YYYY")} - {getYears(job?.job_start, job?.job_stop)} years
                                    </>
                            }
                        </>
                    }
                </Typography>
            </Grid>
            <Grid item xs={2} sx={{paddingTop: "0 !important"}}>
                <Typography
                    style={{padding: "0 10px 0 0", fontSize: "13px"}}
                    gutterBottom
                    variant='span'
                    component='span'
                >
                    {job?.job_title}
                </Typography>
            </Grid>
            <Grid item xs={2} sx={{paddingTop: "0 !important"}}>
                {job?.job_phone !== "" ? (
                    <Typography
                        sx={{
                            padding: "0 20px 0 0",
                            fontSize: "13px",
                        }}
                        gutterBottom
                        variant='div'
                        component='div'
                    >
                        <a
                            href={`callto:${job?.job_phone}`}
                            onClick={props.showActiveTab}
                            style={{
                                textDecoration: "none",
                                color: "inherit",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <span style={{marginRight: "5px", lineHeight: "1px"}}>
                                <Phone sx={{color: "icon.main", fontSize: "15px"}}/>
                            </span>
                            <span>{job?.job_phone}</span>
                        </a>
                    </Typography>
                ) : (
                    <div style={{flex: 1}}></div>
                )}
            </Grid>
            <Grid item xs={4} sx={{paddingTop: "0 !important"}}>
                {
                    !editJobEmail && (
                        <>
                            {job?.job_email !== "" ? (
                                <Typography
                                    sx={{
                                        padding: "0 20px 0 0",
                                        fontSize: "13px",
                                        color: "site.link",
                                    }}
                                    gutterBottom
                                    variant='div'
                                    component='div'
                                >
                                    <a
                                        href={`mailto:${job?.job_email}`}
                                        style={{
                                            textDecoration: "none",
                                            color: "inherit",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                    <span style={{marginRight: "5px", lineHeight: "1px"}}>
                                        <Email sx={{color: "icon.main", fontSize: "18px"}}/>
                                    </span>
                                        <span style={{wordBreak: "break-all"}}>{job?.job_email}</span>
                                        {job?.job_is_primary === 1 && <VerifiedEmailIcon person={{
                                            ...person,
                                            primary_job_email: job.job_email
                                        }}/>}
                                    </a>
                                </Typography>
                            ) : (
                                <div style={{flex: 2}}></div>
                            )}
                        </>)
                }
                {
                    editJobEmail &&
                    <Grid container>
                        <Grid item>
                            <TextField
                                type="email"
                                id="email"
                                label="Primary Job Email"
                                variant="outlined"
                                size="small"
                                style={{marginTop: "10px"}}
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                            ></TextField>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography variant="body2" color="site.main"
                                        sx={{display: 'flex', margin: '15px 0 0 5px'}}>
                                <Check sx={{color: 'green', fontSize: "20px", cursor: 'pointer'}} onClick={(e) => {
                                    e.stopPropagation();
                                    handleUpdatePrimaryJobEmailCheck();
                                }}/>
                                <Clear sx={{color: 'red', fontSize: "20px", cursor: 'pointer'}} onClick={(e) => {
                                    e.stopPropagation();
                                    setEditJobEmail(false);
                                    setEmail(job?.job_email);
                                }}/>
                            </Typography>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    updatePrimaryJobEmailError: opportunitySelectors.updatePrimaryJobEmail_error(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updatePrimaryJobEmail: opportunityActions.updatePrimaryJobEmail,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PersonJobOverview)